import axios from 'axios'

class Course {
  static async get() {
    const res = await axios.get('classroom/courses')

    return res.data
  }
}

export default Course
